/* eslint-disable jsx-a11y/media-has-caption */
import React, { RefObject } from 'react';
// import { useSelector } from 'react-redux';
import cn from 'classnames';

import { BBCommonProps } from 'types/story';
import ChangeIcon from 'common/components/Icon/Change';
import { prependUrlProtocol } from 'common/utils/helpers';
import VideoPlayer from 'common/components/VideoPlayer';
import { IFRAME_ACTIONS, transmitTo } from 'common/utils/iframe-tunnel';
import { SelectionToolbarPortal } from 'client/components/common/SelectionHint/Toolbar';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';

import css from './Video.scss';

type Props = BBCommonProps;

const Video = (props: Props) => {
	// props
	const { editableModeProps: EMP, stateAttrs, isEditableMode, uiConfig } = props;
	// const nodeID = uiConfig.nodeProps.id;
	const { videoSrc, videoPoster, muted, loop, controls, autoplay } = uiConfig.componentProps.other;
	const isHidden = uiConfig.componentProps.styles.display === 'none';
	const src = videoSrc === 'none' || !videoSrc ? '' : prependUrlProtocol(videoSrc, 'https');
	const poster = videoPoster === 'none' || !videoPoster ? '' : prependUrlProtocol(videoPoster, 'https');
	const isLoop = isEditableMode ? false : loop ?? false;
	const isMuted = isEditableMode ? true : muted ?? false;
	const isAutoplay = isEditableMode ? false : autoplay ?? false;
	const isControls = isEditableMode ? false : controls ?? false;

	// state
	// const isSelected = useSelector(useIsSelected(nodeID));

	return (
		<div
			{...uiConfig.nodeProps}
			{...stateAttrs}
			{...props.eventListeners}
			{...EMP?.nodeProps}
			style={uiConfig.nodeProps?.style}
			className={cn(css.video, uiConfig.nodeProps.className, EMP?.nodeProps?.className)}
			ref={props.containerRef as RefObject<HTMLDivElement>}
		>
			{!isHidden && src ? (
				<VideoPlayer
					key={`${props._id}-${src}-${poster}`} // key is important to update preview on src/poster change
					src={src}
					poster={poster}
					controls={isControls}
					muted={isMuted}
					loop={isLoop}
					autoplay={isAutoplay}
					title={uiConfig.componentProps.title}
				/>
			) : (
				<div className={css.empty}>No video</div>
			)}

			{props.isEditableMode && !isHidden && (
				<SelectionToolbarPortal nodeID={uiConfig.nodeProps.id}>
					<button
						title="Repalce video source"
						type="button"
						onClick={() => {
							// Flow: send msg to admin -> read msg -> emit inspector event -> call event listener ->
							// -> call file upload
							transmitTo({
								id: 'Video',
								target: 'admin',
								action: IFRAME_ACTIONS.UPLOAD_MEDIA,
							});
						}}
					>
						<ChangeIcon width={11} />
					</button>
				</SelectionToolbarPortal>
			)}
		</div>
	);
};

export default withCardTransitionContext(Video);
